import { getOrderPaymentState } from '../utils/orderPaymentFilter';

const money = value => `₹${Number(value || 0).toFixed(2)}`;

export default function OrderPaymentStatus({ order, compact = false }) {
  const { total, received, pending, paid, deferred } = getOrderPaymentState(order);
  const status = paid ? 'Paid' : received > 0 ? 'Partially paid' : deferred ? 'Pay Later · Unpaid' : 'Unpaid';
  const color = paid ? 'bg-green-100 text-green-800' : received > 0 ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800';
  return <div className={compact ? 'mt-2 space-y-1 text-xs' : 'rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm'}>
    {!compact && <p className="mb-2 font-semibold text-gray-700">Payment status</p>}
    <span className={`inline-block rounded-full px-2 py-1 font-semibold ${color}`}>{status}</span>
    {compact ? (!paid && <p className="font-semibold text-amber-800">Pending: {money(pending / 100)}</p>) : <>
      <div className="mt-2 flex flex-wrap gap-x-6 gap-y-1"><span>Bill: <strong>{money(total / 100)}</strong></span><span>Paid: <strong className="text-green-700">{money(received / 100)}</strong></span><span>Pending: <strong className="text-amber-800">{money(pending / 100)}</strong></span></div>
      <p className="mt-2 text-gray-600">Payment method: {order.paymentMethod || 'Not recorded'}</p>
      {!!order.paymentBreakdown?.length && <p className="mt-1 text-gray-600">{order.paymentBreakdown.map(row => `${row.channel}: ${money(row.amount)}`).join(' · ')}</p>}
    </>}
  </div>;
}
